<template>
  <Layout>
    <PageTitle />

    <LogsTabs />

    <div class="page-padding page-padding-horizontal">
      <LogsTable />
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layout/inside/index.vue'

import LogsTable from './logsTable/LogsTable.vue'
import LogsTabs from './LogsTabs.vue'

export default {
  page: {
    title: 'Логи',
  },
  components: {
    Layout,
    LogsTable,
    PageTitle: () => import('./PageTitle.vue'),
    LogsTabs,
  },
}
</script>
